import Swiper from "swiper";

export default class {
    constructor() {
        document.addEventListener("DOMContentLoaded", function () {
            var swiper = new Swiper(".swiper-quotes", {
                centeredSlides: false,
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: true,
                },
                loop: true,
            });
        });
    }
}
